export const SharingService = {
    getOwnerIfShared(sharedResources, id, type) {
        if (type === 'product') {
            const foundProduct = sharedResources.products.find((product) => {
                return product.uuid === id;
            });
            if (typeof foundProduct !== 'undefined') {
                return foundProduct.email;
            }
        }

        if (type === 'food') {
            const foundFood = sharedResources.foods.find((food) => {
                return food.uuid === id;
            });
            if (typeof foundFood !== 'undefined') {
                return foundFood.email;
            }
        }

        return false;
    }
};